/**
 * Firmware API endpoints
 * 
 * Public endpoint for firmware download statistics
 */

import apiClient from './client';

export interface FirmwareVersion {
  id: string;
  firmware_version: string;
  pico_version: string;
  release_notes: string;
  file: string;
  is_mandatory: boolean;
  is_active: boolean;
  uploaded_at: string;
  web_download_count: number;
  device_update_count: number;
}

/**
 * Get all firmware versions with download stats
 */
export async function getFirmwareVersions(): Promise<FirmwareVersion[]> {
  const response = await apiClient.get<FirmwareVersion[]>('/firmware/');
  return response.data;
}

export default {
  getFirmwareVersions,
};

